import React from 'react';
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle
}            from 'reactstrap';
import Row
			 from 'reactstrap/es/Row';
import Col
			 from 'reactstrap/es/Col';
import Input
			 from 'reactstrap/es/Input';
import Label
			 from 'reactstrap/es/Label';

class PizzaItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			config: null,
			dropDowns: {
				pipeline: {
					selected: null
				},
				stage: {
					selected: null
				}
			},
			HeaderText: '',
			DescriptionText: ''
		}
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.config !== nextProps.config) {
			return { config: nextProps.config};
		}
		return null;
	}

	toggleSelect = (graph) => {
		var { dropDowns } = this.state;
		dropDowns[graph].open = !dropDowns[graph].open;
		this.setState(dropDowns);
	}

	dropdownSelect = (graph, selection) => {
		var { dropDowns, config } = this.state;
		if (graph === 'pipeline' && selection !== dropDowns['stage'].selected) {
			dropDowns['stage'].selected = null;
			config.StageID = null;
		}
		dropDowns[graph].selected = selection;
		if (graph === 'pipeline') {
			config.PipelineID = selection;
		}
		if (graph === 'stage') {
			config.StageID = selection;
		}
		this.setState({dropDowns: dropDowns, config: config});

		if (this.props.onConfigChange) {
			this.props.onConfigChange(config, this.props.configIndex);
		}

	}

	onInputChanged = (event) => {
		var {config} = this.state;
		switch (event.target.name) {
			case 'HeaderText':
				config.HeaderText = event.target.value;
				break;
			case 'DescriptionText':
				config.DescriptionText = event.target.value;
				break;
			default:
				return;
		}
		if (this.props.onConfigChange) {
			this.props.onConfigChange(config, this.props.configIndex);
		}
	}

	onDeleteConfig = () => {
		if (this.props.onDeleted) {
			this.props.onDeleted(this.props.configIndex);
		}
	}

	render() {
		const {config, dropDowns} = this.state;
		const selectedPipe = this.props.pipedrive.Pipelines.find(p => {
			return p.ID === dropDowns['pipeline'].selected || p.ID === config.PipelineID;
		});
		const validStages = this.props.pipedrive.Stages.filter(s => {
			if (selectedPipe) {
				return s.PipelineID === selectedPipe.ID;
			}
			return false;
		})
		const selectedStage = this.props.pipedrive.Stages.find(s => {
			return s.ID === dropDowns['stage'].selected || s.ID === config.StageID;
		});

		return (
			<>
				{config && <div className={`pizza-item--item-card`}>
					<Row>
						<Col xs={12}>
							<h4>Step {this.props.configIndex + 1}</h4>
						</Col>
					</Row>
						<Row>
							<i className={`fa fa-trash`} onClick={this.onDeleteConfig}></i>
							<Col xs={12} md={3}>
								<h5>Pipeline</h5>
								<Dropdown isOpen={dropDowns['pipeline'].open} toggle={() => this.toggleSelect('pipeline')}>
									<DropdownToggle caret>
										{selectedPipe && selectedPipe.Name || 'Select Pipeline'}
									</DropdownToggle>
									<DropdownMenu>
										<DropdownItem header>Select a Pipeline</DropdownItem>
										<DropdownItem key={'All'} onClick={ () => this.dropdownSelect('pipeline', null) }>Select Pipeline</DropdownItem>
										{
											this.props.pipedrive.Pipelines.map(p => {
												if (p.ID == dropDowns['pipeline'].selected || p.ID == config.PipelineID) {
													return <DropdownItem key={p.ID} disabled>{p.Name}</DropdownItem>

												}
												return <DropdownItem key={p.ID} onClick={ () => this.dropdownSelect('pipeline', p.ID) }>{p.Name}</DropdownItem>
											})
										}
									</DropdownMenu>
								</Dropdown>
							</Col>
							{selectedPipe &&
								<Col xs={12} md={3}>
									<h5>Stage</h5>
									<Dropdown isOpen={dropDowns['stage'].open} toggle={() => this.toggleSelect('stage')}>
										<DropdownToggle caret>
											{selectedStage && selectedStage.Name || 'Select Stage'}
										</DropdownToggle>
										<DropdownMenu>
											<DropdownItem header>Select
												a
												Stage</DropdownItem>
											<DropdownItem key={'All'} onClick={() => this.dropdownSelect('stage', null)}>Select
												Stage</DropdownItem> {
											validStages.map(s => {
												if (s.ID == dropDowns['stage'].selected) {
													return <DropdownItem key={s.ID} disabled>{s.Name}</DropdownItem>

												}
												return <DropdownItem key={s.ID} onClick={() => this.dropdownSelect('stage', s.ID)}>{s.Name}</DropdownItem>
											})
										}
										</DropdownMenu>
									</Dropdown>
								</Col>
							}
						</Row>
						<Row>
							<Col xs={12} sm={6}>
								<Label for={`HeaderText`}>Header Text</Label><Input name={`HeaderText`} onChange={this.onInputChanged} value={config.HeaderText} />
							</Col>
						</Row>
						<Row>
							<Col xs={12} sm={6}>
								<Label for={`DescriptionText`}>Description Text</Label><Input name={`DescriptionText`} onChange={this.onInputChanged} value={config.DescriptionText} />
							</Col>
						</Row>
				</div>}
			</>
		)
	}
}

export default PizzaItem;